// extracted by mini-css-extract-plugin
export default {"complexModeModal":"styles_complex-mode-modal__8-i0g","complexModeModal__applicationArea":"styles_complex-mode-modal__application-area__pjeCw"};